export default "__VITE_ASSET__DgbbwGLb__"